<template>
  <dl class="table_box" :class="isWithHeader ? 'with-header' : ''">
    <template v-for="(value, key, index) in tableContents">
      <dt :key="key + index">{{value.dt}}</dt>
      <dd :key="value + index">{{value.dd}}</dd>
    </template>
  </dl>
</template>

<script>
  export default {
    name: "TableBox",

    props: {
      tableContents: {
        type: Object,
        required: true
      },
      isWithHeader: {
        type: Boolean,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .table_box {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    border-left: 1px solid $border_color;
    border-bottom: 1px solid $border_color;

    > dt, dd {
      margin: 0;
      border-top: 1px solid $border_color;
      border-right: 1px solid $border_color;
      padding: 1rem;
    }

    > dt {
      font-size: $big-font-size;
      font-weight: bold;
      border-right: 1px solid $border_color;
      width: 50%;
    }

    > dd {
      width: 50%;
      border-left: none;
      white-space: pre-line;
    }

    &.with-header {
      dt:nth-child(1), dd:nth-child(2) {
        background-color: $third_color;
        text-align: center;
        font-weight: bold;
      }
    }
  }
</style>
